import DeepMapKeys from 'deep-map-keys';

export default function(props) {
  // theme prop overwrites styled components theme prop from themeProvider,
  // so we rename it
  return DeepMapKeys(props, (key) => key === 'theme' ? 'colorTheme' : key);
}
